import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@occc-app/design-system';

import { PointChangeViewItem } from './PointChangeViewItem';
import { PointChangeViewItemData } from './types';
import { PointChangeViewSubItem } from './PointChangeViewSubItem';

type Props = {
  items: PointChangeViewItemData[];
};

export const PointChangeViewItems = (props: Props) => {
  const { items } = props;
  const hasDates = items.some((v) => v.offer && (v.offer.startDate || v.offer.endDate));

  return (
    <TableContainer
      sx={(theme) => ({
        marginBottom: theme.spacing(1),
      })}
    >
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Item</TableCell>
            {hasDates && (
              <>
                <TableCell>Start Date</TableCell>
                <TableCell>End Date</TableCell>
              </>
            )}
            <TableCell align='right'>Amount</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((item) => (
            <PointChangeViewItem
              key={item.id}
              item={item}
              isAmountHidden={!!item.offer || !!item.donation}
            >
              {item.offer ? (
                <PointChangeViewSubItem
                  name={item.offer.name}
                  title={item.offer.title}
                  link={item.offer.url}
                  total={item.amount}
                />
              ) : item.donation ? (
                <PointChangeViewSubItem
                  name={item.donation.bucketName}
                  total={item.donation.pointsSpent}
                />
              ) : null}
            </PointChangeViewItem>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
